import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72154e3b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "badge" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-city fa-lg mr-2 mt-2" }, null, -1));
const _hoisted_3 = { class: "level is-mobile" };
const _hoisted_4 = { class: "adaptiveLabel" };
const _hoisted_5 = {
    key: 0,
    class: "tag is-danger is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_6 = {
    key: 1,
    class: "tag is-warning is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_7 = {
    key: 2,
    class: "tag is-warning is-light is-rounded has-text-weight-bold ml-1"
};
import { canSeeFeature } from "@/core/session";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerBadge',
    props: {
        partner: {},
        disabled: { type: Boolean },
        noLink: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createBlock(_resolveDynamicComponent(!_ctx.noLink && _unref(canSeeFeature)('partners') ? 'router-link' : 'span'), {
                to: `/partners/${(_a = _ctx.partner) === null || _a === void 0 ? void 0 : _a.id}`
            }, {
                default: _withCtx(() => {
                    var _a, _b;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            _hoisted_2,
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createTextVNode(_toDisplayString(_ctx.partner ? _ctx.partner.name : "Not assigned") + " ", 1),
                                    (_ctx.disabled)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Hidden"))
                                        : _createCommentVNode("", true),
                                    ((_a = _ctx.partner) === null || _a === void 0 ? void 0 : _a.isTestPartner)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Test"))
                                        : _createCommentVNode("", true),
                                    ((_b = _ctx.partner) === null || _b === void 0 ? void 0 : _b.isPendingApproval)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Pending Approval"))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ];
                }),
                _: 1
            }, 8, ["to"]));
        };
    }
});
